<section class="section-pd bg-light-purple paraphrasingModes">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>多種文章改寫模式，滿足你的寫作需求</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active"data-toggle="tab" href="#standard">標準模式</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"data-toggle="tab" href="#academic">學術模式</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"data-toggle="tab" href="#formal">正式模式</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"data-toggle="tab" href="#concise">簡潔模式</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"data-toggle="tab" href="#simple">簡單模式</a>
                    </li>
                </ul>
                
                <!-- Tab panes -->
                <div class="tab-content bg-white">
                    <!-- Standard Tab -->
                    <div id="standard" class="tab-pane active">
                        <div class="pt-content">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <p class="mb-30">透過調整詞彙或句子結構，重新改寫你的文字。</p>
                                </div>
                                <div class="col-5">
                                    <p><b>範例：</b></p>
                                </div>
                                <div class="col-7">
                                    <div class="trinkaToggleButton mb-3 justify-content-end">
                                        <div class="trinkaToogleWrapper">
                                            <p>Show Revision</p>
                                            <label class="switch" style="margin:0 8px;">
                                                <input type="checkbox" [(ngModel)]="standardExample" checked>
                                                <span class="slider-rd round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="exampleContainer">
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>原文</h6>
                                        <p>Infectious disease epidemics cause a decline in screening uptake among asymptomatic individuals, leading to concerns regarding advanced cancer cases and mortality.</p>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="seperator">
                                        <span>
                                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>改寫後文字</h6>
                                        <p [ngClass]="{'hidden': !standardExample}">
                                            <i class="wrongTextParaphrased">Infectious disease epidemics cause a decline</i>
                                            <i class="RightTextParaphrased">Epidemics of infectious diseases result</i>
                                            in
                                            <i class="wrongTextParaphrased">screening uptake among</i>
                                            <i class="RightTextParaphrased">a decrease in the number of</i>
                                            asymptomatic individuals,
                                            <i class="wrongTextParaphrased">leading</i> who
                                            <i class="RightTextParaphrased">undergo screening, giving rise</i>
                                            to concerns
                                            <i class="wrongTextParaphrased">regarding</i>
                                            <i class="RightTextParaphrased">about</i>
                                            a rise in advanced cancer
                                            <i class="RightTextParaphrased">cases</i>
                                            and
                                            <i class="wrongTextParaphrased">deaths increased</i>
                                            <i class="RightTextParaphrased">mortality.</i>
                                        </p>
                                        <p [ngClass]="{'hidden': standardExample}">Epidemics of infectious diseases result in a decrease in the number of asymptomatic individuals who undergo screening, giving rise to concerns about a rise in advanced cancer cases and mortality.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Academic Tab -->
                    <div id="academic" class="tab-pane fade">
                        <div class="pt-content">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <p class="mb-30">讓你的寫作符合學術規範。</p>
                                </div>
                                <div class="col-5">
                                    <p><b>範例：</b></p>
                                </div>
                                <div class="col-7">
                                    <div class="trinkaToggleButton mb-3 justify-content-end">
                                        <div class="trinkaToogleWrapper">
                                            <p>Show Revision</p>
                                            <label class="switch" style="margin:0 8px;">
                                                <input type="checkbox" [(ngModel)]="academicExample" checked>
                                                <span class="slider-rd round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="exampleContainer">
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>原文</h6>
                                        <p>This work could help us figure out how other bugs that live in colonies, like ants and bees, deal with different bio situations in nature</p>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="seperator">
                                        <span>
                                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>改寫後文字</h6>
                                        <p [ngClass]="{'hidden': !academicExample}">
                                            This
                                            <i class="wrongTextParaphrased">work</i>
                                            <i class="RightTextParaphrased">research</i>
                                            <i class="wrongTextParaphrased">could help us figure out</i>
                                            <i class="RightTextParaphrased">may contribute to a deeper understanding of</i> how other
                                            <i class="wrongTextParaphrased">bugs that live in colonies</i>
                                            <i class="RightTextParaphrased">social insects,</i>
                                            <i class="wrongTextParaphrased">likes</i>
                                            <i class="RightTextParaphrased">such as</i> ants and bees,
                                            <i class="wrongTextParaphrased">deal with different</i>
                                            <i class="RightTextParaphrased">adapt to diverse</i>
                                            <i class="wrongTextParaphrased">bio situation in nature</i>
                                            <i class="RightTextParaphrased">environmental conditions in their natural habitats.</i>
                                        </p>
                                        
                                        <p [ngClass]="{'hidden': academicExample}">This research may contribute to a deeper understanding of how other social insects, such as ants and bees, adapt to diverse environmental conditions in their natural habitats.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Formal Tab -->
                    <div id="formal" class="tab-pane fade">
                        <div class="pt-content">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <p class="mb-30">讓你的文筆聽起來更專業、更正式。</p>
                                </div>
                                <div class="col-5">
                                    <p><b>範例：</b></p>
                                </div>
                                <div class="col-7">
                                    <div class="trinkaToggleButton mb-3 justify-content-end">
                                        <div class="trinkaToogleWrapper">
                                            <p>Show Revision</p>
                                            <label class="switch" style="margin:0 8px;">
                                                <input type="checkbox" [(ngModel)]="formalExample" checked>
                                                <span class="slider-rd round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="exampleContainer">
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>原文</h6>
                                        <p>Can we move that meeting up with the HR folks to 9:30 am?</p>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="seperator">
                                        <span>
                                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>改寫後文字</h6>
                                        <p [ngClass]="{'hidden': !formalExample}">
                                            Can we
                                            <i class="wrongTextParaphrased">move that</i>
                                            <i class="RightTextParaphrased">reschedule our</i>
                                            meeting
                                            <i class="wrongTextParaphrased">up</i> with the HR
                                            <i class="wrongTextParaphrased">folks</i>
                                            <i class="RightTextParaphrased">department</i> to 9:30 am?
                                        </p>
                                            
                                        
                                        <p [ngClass]="{'hidden': formalExample}">Can we reschedule our meeting with the HR department to 9:30 am?</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Concise Tab -->
                    <div id="concise" class="tab-pane fade">
                        <div class="pt-content">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <p class="mb-30">讓您的文章言簡意賅，表達更有力。</p>
                                </div>
                                <div class="col-5">
                                    <p><b>範例：</b></p>
                                </div>
                                <div class="col-7">
                                    <div class="trinkaToggleButton mb-3 justify-content-end">
                                        <div class="trinkaToogleWrapper">
                                            <p>Show Revision</p>
                                            <label class="switch" style="margin:0 8px;">
                                                <input type="checkbox" [(ngModel)]="conciseExample" checked>
                                                <span class="slider-rd round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="exampleContainer">
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>原文</h6>
                                        <p>In this study, recent works on the thermal conductivity of nanofluids are examined to gain the best insights into and understanding of the influential parameters that affect thermal conductivity.</p>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="seperator">
                                        <span>
                                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>改寫後文字</h6>
                                        <p [ngClass]="{'hidden': !conciseExample}">
                                            <i class="wrongTextParaphrased">In this study, recent works</i>
                                            <i class="RightTextParaphrased">Recent research</i>
                                            on the thermal conductivity of nanofluids
                                            <i class="wrongTextParaphrased">are examined</i>
                                            <i class="RightTextParaphrased">is reviewed</i> to
                                            <i class="wrongTextParaphrased">gain the best insights into and</i>
                                            <i class="RightTextParaphrased">provide a comprehensive</i> understanding of the
                                            <i class="wrongTextParaphrased">influential parameters that affect</i>
                                            <i class="RightTextParaphrased">factors impacting</i> thermal conductivity.
                                        </p>
                                        <p [ngClass]="{'hidden': conciseExample}">Recent research on the thermal conductivity of nanofluids is reviewed to provide a comprehensive understanding of the factors impacting thermal conductivity.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Simple Tab -->
                    <div id="simple" class="tab-pane fade">
                        <div class="pt-content">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <p class="mb-30">讓您的文章表達更清晰易懂。</p>
                                </div>
                                <div class="col-5">
                                    <p><b>範例：</b></p>
                                </div>
                                <div class="col-7">
                                    <div class="trinkaToggleButton mb-3 justify-content-end">
                                        <div class="trinkaToogleWrapper">
                                            <p>Show Revision</p>
                                            <label class="switch" style="margin:0 8px;">
                                                <input type="checkbox" [(ngModel)]="simpleExample" checked>
                                                <span class="slider-rd round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="exampleContainer">
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>原文</h6>
                                        <p>Idarucizumab binds to dabigatran and quickly reverses its anticoagulant effects.</p>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="seperator">
                                        <span>
                                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke="#7A28A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="exampleContent">
                                    <div class="statementText">
                                        <h6>改寫後文字</h6>
                                        <p [ngClass]="{'hidden': !simpleExample}">
                                            Idarucizumab
                                            <i class="wrongTextParaphrased">binds</i>
                                            <i class="RightTextParaphrased">attaches</i>
                                            to dabigatran and
                                            <i class="wrongTextParaphrased">quickly</i>
                                            <i class="RightTextParaphrased">rapidly</i>
                                            reverses its
                                            <i class="wrongTextParaphrased">anticoagulant</i>
                                            <i class="RightTextParaphrased">blood-thinning</i>
                                            effects.
                                        </p>
                                        <p [ngClass]="{'hidden': simpleExample}">Idarucizumab attaches to dabigatran and rapidly reverses its blood-thinning effects.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>